enum Paths {
    shippingMethod = '/shipping/methods',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/ShippingMethod/paths.ts